/**
 * Show the "products out of stock" modal.
 *
 * @returns {void}
 */
function showProductsOosModal() {
    document.getElementById("lux-modal-products-oos")?.classList.add("active");
}

window.showProductsOosModal = showProductsOosModal;

export {};
